import { types } from "mobx-state-tree";

export const AnswerStore = types.model({
  id: types.identifierNumber,
  content: types.maybeNull(types.string),
  is_correct: types.maybeNull(types.boolean),
  image_url: types.maybeNull(types.string),
});

export const UserAnswerStore = types.model({
  id: types.identifierNumber,
  answer_id: types.integer,
  question_id: types.integer,
  is_correct: types.boolean,
  answer: types.maybeNull(AnswerStore),
});

export const QuestionStore = types
  .model({
    id: types.identifierNumber,
    content: types.maybeNull(types.string),
    image_url: types.maybeNull(types.string),
    score: types.optional(types.integer, 0),
    order: types.maybeNull(types.integer),
    is_correct: types.maybeNull(types.integer),
    type: types.maybeNull(types.enumeration(["single", "multiple"])),
    answers: types.array(AnswerStore),
    userAnswers: types.maybeNull(types.array(UserAnswerStore)),
    explanation: types.maybeNull(types.string),
  })
  .actions((self) => {
    const checkSelectedAnswer = (answerId) => {
      const userAnswer = self.userAnswers.find((userAnswer) => userAnswer.answer_id === answerId);

      if (!userAnswer) return null;

      return userAnswer?.is_correct;
    };

    return {
      checkSelectedAnswer,
    };
  });

export const UserQuizStore = types.model({
  id: types.identifierNumber,
  status: types.maybeNull(types.enumeration(["done", "redo"])),
  score: types.integer,
});

export const QuizStore = types
  .model({
    id: types.identifierNumber,
    timing: types.maybeNull(types.integer),
    total_score: types.maybeNull(types.integer),
    questions: types.array(QuestionStore),
    userQuiz: types.maybeNull(UserQuizStore),
  })
  .actions((self) => {
    const fillable = ["timing", "total_score"];

    const update = (newData) => {
      fillable.forEach((field) => {
        if (!!newData[field]) {
          self[field] = newData[field];
        }
      });

      if (!!newData.questions) {
        self.questions = newData["questions"];
      }

      if (!!newData.userQuiz) {
        self.userQuiz = newData["userQuiz"];
      }
    };

    const addQuestion = (newQuestion) => {
      if (newQuestion) {
        self.questions.push(newQuestion);
      }
    };

    const updateQuestion = (id, newQuestion) => {
      const index = self.questions.findIndex((question) => question.id === id);

      self.questions[index] = newQuestion;
    };

    const updateScore = () => {
      const score = self.questions.reduce((accu, curr) => accu + curr.score, 0);
      self.total_score = score;
    };

    const changeQuestionOrder = (direction, index) => {
      const questions = self.questions;

      switch (direction) {
        case "up":
          if (index <= 0) break;
          questions[index - 1].order++;
          questions[index].order--;
          break;

        case "down":
          if (index >= questions.length - 1) break;
          questions[index + 1].order--;
          questions[index].order++;
          break;
      }

      return questions.sort((a, b) => a.order - b.order);
    };

    const sortQuestion = () => {
      const questions = self.questions;
      return questions.sort((a, b) => a.order - b.order);
    };

    const deleteQuestion = (questionId) => {
      self.questions = self.questions.filter((q) => q.id !== questionId);
    };

    return {
      update,

      addQuestion,
      updateQuestion,
      updateScore,
      changeQuestionOrder,
      sortQuestion,
      deleteQuestion,
    };
  });
